// Home Search criteria on a contact (stored flat on the contact record):
// interestedCity, interestedDevelopment, priceMin, priceMax, propertyTypes[], minBeds, minBaths, sqftMin, sqftMax.
// "+" options store the top value; e.g. priceMax 5000000 shown as $5M+.
const range = (from, to, step) => { const out = []; for (let v = from; v <= to; v += step) out.push(v); return out; };
export const PRICE_OPTIONS = range(100000, 5000000, 50000);
export const SQFT_OPTIONS = range(500, 6000, 100);
export const BED_OPTIONS = [1, 2, 3, 4, 5, 6];
export const BATH_OPTIONS = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
export const PROPERTY_TYPES = ['Single-Family', 'Villa', 'Condo', 'Townhome'];
export const CITY_SUGGESTIONS = ['Naples', 'Bonita Springs', 'Estero', 'Fort Myers', 'Cape Coral', 'Marco Island'];

const TOP_PRICE = PRICE_OPTIONS[PRICE_OPTIONS.length - 1];
const TOP_SQFT = SQFT_OPTIONS[SQFT_OPTIONS.length - 1];
export const fmtPrice = (v) => {
  if (!v) return '';
  const n = Number(v);
  const s = n >= 1000000 ? `$${(n / 1000000).toFixed(n % 1000000 ? 2 : 0).replace(/\.?0+$/, '')}M` : `$${Math.round(n / 1000)}k`;
  return n >= TOP_PRICE ? `${s}+` : s;
};
export const fmtSqft = (v) => (v ? `${Number(v).toLocaleString()}${Number(v) >= TOP_SQFT ? '+' : ''} sq ft` : '');
const plus = (v, top) => (v ? `${v}${Number(v) >= top ? '+' : ''}` : '');

export const priceRangeText = (c = {}) => {
  if (c.priceMin && c.priceMax) return `${fmtPrice(c.priceMin)} to ${fmtPrice(c.priceMax)}`;
  if (c.priceMin) return `${fmtPrice(c.priceMin)}+`;
  if (c.priceMax) return `up to ${fmtPrice(c.priceMax)}`;
  return '';
};
export const sqftRangeText = (c = {}) => {
  if (c.sqftMin && c.sqftMax) return `${Number(c.sqftMin).toLocaleString()} to ${fmtSqft(c.sqftMax)}`;
  if (c.sqftMin) return `${fmtSqft(c.sqftMin)}+`.replace('++', '+');
  if (c.sqftMax) return `up to ${fmtSqft(c.sqftMax)}`;
  return '';
};
export const propertyTypesText = (c = {}) => (c.propertyTypes || []).join(', ');
export const bedsText = (c = {}) => (c.minBeds ? `${plus(c.minBeds, 6)} bd` : '');
export const bathsText = (c = {}) => (c.minBaths ? `${plus(c.minBaths, 5)} ba` : '');

// One-line summary, e.g. "Naples · Esplanade · $400k to $650k · Villa, Condo · 3 bd · 2 ba · 1,800 to 2,500 sq ft"
export const homeSearchSummary = (c = {}) => [c.interestedCity, c.interestedDevelopment, priceRangeText(c), propertyTypesText(c), bedsText(c), bathsText(c), sqftRangeText(c)].filter(Boolean).join(' · ');

// Contacts list filters.
export const matchesBudget = (c, price) => {
  if (!price) return true;
  const p = Number(price);
  if (!c.priceMin && !c.priceMax) return false;
  return (!c.priceMin || Number(c.priceMin) <= p) && (!c.priceMax || Number(c.priceMax) >= TOP_PRICE || Number(c.priceMax) >= p);
};
